import {useState} from 'react';

import {DynamicStatusButton} from 'shells/button/dynamic-status-button/dynamic-status-button';

import type {
    CalendarSync,
    GetCalendars_calendars as ConflictCalendar,
} from 'nutshell-graphql-types';

import {appHistory} from '../../../history';

import {useSetGoogleCalendarSyncIsEnabled} from '../../setup/calendar/graphql/hooks/use-set-google-calendar-sync-is-enabled';
import {useSetOffice365CalendarSyncIsEnabled} from '../../setup/calendar/graphql/hooks/use-set-office365-calendar-sync-is-enabled';

import {
    getStatusText,
    getFlashBannerType,
    getStatusDescription,
    getPopoverContent,
} from './helpers';

type Props = {
    calendarSyncStatus: CalendarSync | null | undefined;
    conflictCalendars: ConflictCalendar[];
    refetchSyncStatus: () => Promise<any>;
    error: string | null | undefined;
    conflictSyncError: string | null | undefined;
    setIsOnboardingModalOpen: (isOpen: boolean) => void;
    setIsEditModalOpen: (isOpen: boolean) => void;
    setIsReconnectOnboardingModalOpen: (isOpen: boolean) => void;
};

export function CalendarStatusButton(props: Props) {
    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

    const {setGoogleCalendarSyncIsEnabled} = useSetGoogleCalendarSyncIsEnabled();
    const {setOffice365CalendarSyncIsEnabled} = useSetOffice365CalendarSyncIsEnabled();

    return (
        <DynamicStatusButton
            text={getStatusText(props.calendarSyncStatus, props.error, props.conflictSyncError)}
            headerType={getFlashBannerType(
                props.calendarSyncStatus,
                props.error,
                props.conflictSyncError
            )}
            headerContent={getStatusDescription(
                props.calendarSyncStatus,
                props.error,
                props.conflictSyncError
            )}
            isDialogOpen={isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            popoverContent={getPopoverContent({
                status: props.calendarSyncStatus,
                conflictCalendars: props.conflictCalendars,
                refetchSyncStatus: props.refetchSyncStatus,
                errorMessage: props.error,
                setGoogleCalendarSyncIsEnabled,
                setOffice365CalendarSyncIsEnabled,
                setIsOnboardingModalOpen: props.setIsOnboardingModalOpen,
                setIsEditModalOpen: props.setIsEditModalOpen,
                setIsReconnectOnboardingModalOpen: props.setIsReconnectOnboardingModalOpen,
                setIsDialogOpen,
                appHistory,
            })}
        />
    );
}
